import { useCallback, MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import useOrderActions from 'data/hooks/useOrderActions';

const useConnect = (orderId: string) => {
  const { location, push } = useHistory();
  const { printOrder, markComplete, markReady, isLoading } = useOrderActions();

  const goToOrder = useCallback(() => {
    const newLocation = {
      pathname: `/orders/${orderId}`,
      state: { prevPathname: location.pathname },
    };

    push(newLocation);
  }, [location, push, orderId]);

  const handlePrintOrder = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      printOrder({ orderId });
    },
    [printOrder, orderId],
  );

  const handleClickSelect = useCallback((event: MouseEvent<any>) => {
    event.stopPropagation();
  }, []);

  const handleChangeSelect = useCallback(
    async (event: React.ChangeEvent<{ label?: string; value: unknown }>) => {
      const newState = event.target.value;

      if (newState === 'COMPLETE') {
        markComplete({ orderId });
      }

      if (newState === 'READY') {
        markReady({ orderId });
      }
    },
    [markReady, markComplete, orderId],
  );

  return {
    goToOrder,
    handlePrintOrder,
    handleClickSelect,
    handleChangeSelect,
    isLoading,
  };
};

export default useConnect;
